//third-party
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";
//custom modules
import Prompt from "./Prompt";
import AiAnswer from "./AiAnswer";
import Spinner from "./Spinner";
import { aiProcessing } from "../FileUploader/CommonFunc";
import { createArticle, getContentMenu } from "../Site/CommonFunc";
//styles
import "./style.scss";

export default function MainGate({ file, setAiDialog }) {
	//states
	const [aiAnswerText, setAiAnswerText] = useState("");
	const [selectedFile, setSelectedFile] = useState(null);
	const [prompt, setPrompt] = useState("");
	const [busy, setBusy] = useState(false);
	const [createArticleFlag, setCreateArticleFlag] = useState(false);

	//hooks
	const navigate = useNavigate();

	//#region functions
	const aiAnalyse = async () => {
		setBusy(true);
		const text = await aiProcessing(selectedFile.fileId, prompt);
		setAiAnswerText(text);
		setBusy(false);
		if (createArticleFlag) {
			const menuArray = await getContentMenu();
			const newArticleObject = await createArticle(
				menuArray[0].ID,
				`ИИ ответ ${getDateTimeString()}`,
				text
			);
			navigate({
				pathname: "/site",
				search: `?id=${newArticleObject[0]?.ID}`,
			});
		}
	};

	const handleArticleCreation = () => setCreateArticleFlag((prev) => !prev);

	const getDateTimeString = () => {
		let date = new Date();
		const timeString = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
		const dateString = ` ${date.getDate()}.${
			date.getMonth() + 1
		}.${date.getFullYear()}`;
		return timeString + dateString;
	};
	//#endregion

	//#region effects
	useEffect(() => {
		setSelectedFile(file);
	}, []);
	//#endregion

	return createPortal(
		<div className='ai-analyse-main'>
			<div className='ai-analyse-container'>
				<div className='header'>
					<span>{selectedFile?.name}</span>
					<div className='close-button' onClick={() => setAiDialog(false)}>
						Закрыть
					</div>
				</div>
				<Prompt prompt={prompt} setPrompt={setPrompt} />
				{selectedFile?.fileId && prompt && (
					<div className='analyse-action-panel'>
						<button style={{ cursor: "pointer", flex: 1 }} onClick={aiAnalyse}>
							Анализ
						</button>
						<div className='check-box-wrapper' onClick={handleArticleCreation}>
							<div className='check-box' data-checked={createArticleFlag}></div>
							<span className='label'>Создать статью на основе ответа ИИ</span>
						</div>

						{busy ? <Spinner /> : null}
					</div>
				)}
				{busy || aiAnswerText === "" ? null : (
					<AiAnswer aiAnswerText={aiAnswerText} />
				)}
			</div>
		</div>,
		document.body
	);
}
